/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Addr_Field_House_NumberInputs */

const cs_addr_field_house_number = /** @type {(inputs: Addr_Field_House_NumberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Číslo popisné`)
};

const en_addr_field_house_number = /** @type {(inputs: Addr_Field_House_NumberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`House number`)
};

/**
* | output |
* | --- |
* | "House number" |
*
* @param {Addr_Field_House_NumberInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const addr_field_house_number = /** @type {((inputs?: Addr_Field_House_NumberInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Addr_Field_House_NumberInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_addr_field_house_number(inputs)
	return cs_addr_field_house_number(inputs)
});